import React, { ComponentProps } from "react";

import { truthy } from "@examspark/common";
import { useModal } from "@examspark/common-app";
import {
  Button,
  ButtonMenu,
  Menu,
  MenuButtons,
  MenuItem,
} from "@examspark/common-ui";
import { IconMoreLine } from "@examspark/common-ui/dist/components/icons";

type Props = {
  buttons?: Array<false | undefined | null | ComponentProps<typeof MenuItem>>;
  disabled?: boolean;
};

const PageMenu = ({ buttons, disabled }: Props) => {
  const menu = useModal();

  const actualButtons = buttons?.filter(truthy);

  if (!actualButtons?.length) return null;

  return (
    <>
      <ButtonMenu
        button={
          <Button
            variant="outlined"
            icon={<IconMoreLine />}
            title="More Options"
            disabled={disabled}
          />
        }
        expanded={menu.isOpen}
        onExpandedChange={menu.setIsOpen}
      >
        <Menu>
          <MenuButtons>
            {actualButtons.map(({ children, ...props }, index) => (
              <MenuItem key={index} {...props}>
                {children ?? props.title}
              </MenuItem>
            ))}
          </MenuButtons>
        </Menu>
      </ButtonMenu>
    </>
  );
};

export default PageMenu;
